export const upsellBannerOrientations = {
  horizontal: 'horizontal',
  vertical: 'vertical',
}
